import type { PublicBillPerson } from "@boo/shared";
import FriendAvatar from "@/components/FriendAvatar";
import { publicAvatarUrl } from "@/services/publicBillApi";

/** A friend's avatar on the shared page; photos come from the token-scoped endpoint. */
export default function PublicPersonAvatar({
  token,
  person,
  size = 28,
}: {
  token: string;
  person: PublicBillPerson;
  size?: number;
}) {
  if (person.isOwner) return null;
  return (
    <FriendAvatar
      name={person.name}
      avatar={person.avatar}
      photoSrc={
        person.avatar?.kind === "image"
          ? publicAvatarUrl(token, person.id, person.avatar.version)
          : undefined
      }
      size={size}
    />
  );
}
